import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import RegistrationApprovalControl from '../RegistrationStep/ImageRegistrations/RegistrationPanel/RegistrationApprovalControl';
import { ReviewTransforms } from './useReviewTransforms';

interface ReviewRegistrationsPanelProps {
    readonly transforms: ReviewTransforms;
}

// The run's registrations, each with its own sign-off.
export default function ReviewRegistrationsPanel({
    transforms,
}: ReviewRegistrationsPanelProps) {
    if (transforms.options.length === 0) {
        return (
            <Typography fontSize={11.5} color="text.secondary">
                <FormattedMessage id="replanning.review.transform.none" />
            </Typography>
        );
    }
    return (
        <Stack spacing={0.5} data-testid="replanning-review-registrations">
            {transforms.options.map((option) => (
                <RegistrationApprovalControl
                    key={option.sopInstanceUid}
                    sopInstanceUid={option.sopInstanceUid}
                    approvalStatus={option.registration.approvalStatus}
                    labelId={`replanning.review.transform.approval.${option.kind}`}
                />
            ))}
        </Stack>
    );
}
